import { lazyLoad } from 'utils/loadable';

export const CrmEmailMailgunRouteSettingsComponent = lazyLoad(
  () => import('./index'),
  module => module.CrmEmailMailgunRouteSettingsComponent,
);
